import { Plus, Trash2, X } from "lucide-react";

const input = "bg-slate-800 border border-slate-700 rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:border-orange-500";
const newOption = () => ({ name: "", price: "", available: true });

export const VariantEditor = ({ groups, onChange, currency }) => {
  const setGroup = (gi, patch) => onChange(groups.map((g, i) => (i === gi ? { ...g, ...patch } : g)));
  const setOpt = (gi, oi, patch) => setGroup(gi, { options: groups[gi].options.map((o, i) => (i === oi ? { ...o, ...patch } : o)) });
  return (
    <div data-testid="variant-editor">
      <label className="text-xs font-medium uppercase tracking-wider text-slate-400">Variants (diner must pick one of each)</label>
      {groups.length > 0 && <p className="text-xs text-slate-500 mt-1">The first group sets the full price. Later groups add their price on top (use 0 for no charge).</p>}
      <div className="space-y-3 mt-2">
        {groups.map((g, gi) => (
          <div key={g.id || `g-${gi}`} className="border border-slate-700 rounded-xl p-3 space-y-2">
            <div className="flex gap-2">
              <input data-testid={`variant-group-name-${gi}`} required placeholder={gi === 0 ? "e.g. Size" : "e.g. Spice level"} value={g.name} onChange={(e) => setGroup(gi, { name: e.target.value })} className={`${input} flex-1 min-w-0 font-semibold`} />
              <button type="button" data-testid={`variant-group-remove-${gi}`} onClick={() => onChange(groups.filter((_, i) => i !== gi))} className="px-3 rounded-xl text-slate-400 hover:text-white transition-colors"><X className="h-4 w-4" /></button>
            </div>
            {g.options.map((o, oi) => (
              <div key={o.id || `o-${oi}`} className="flex gap-2">
                <input data-testid={`variant-option-name-${gi}-${oi}`} required placeholder={gi === 0 ? "e.g. Large" : "e.g. Mild"} value={o.name} onChange={(e) => setOpt(gi, oi, { name: e.target.value })} className={`${input} flex-1 min-w-0`} />
                <input data-testid={`variant-option-price-${gi}-${oi}`} required type="number" min="0" step="0.01" placeholder={gi === 0 ? `Price ${currency || "$"}` : `+${currency || "$"}`} value={o.price} onChange={(e) => setOpt(gi, oi, { price: e.target.value })} className={`${input} w-24`} />
                <button type="button" data-testid={`variant-option-remove-${gi}-${oi}`} disabled={g.options.length === 1} onClick={() => setGroup(gi, { options: g.options.filter((_, i) => i !== oi) })} className="px-3 rounded-xl bg-red-950/50 text-red-400 hover:bg-red-900/60 disabled:opacity-30 transition-colors">
                  <Trash2 className="h-3.5 w-3.5" />
                </button>
              </div>
            ))}
            <button type="button" data-testid={`variant-option-add-${gi}`} onClick={() => setGroup(gi, { options: [...g.options, newOption()] })} className="inline-flex items-center gap-1.5 text-xs text-orange-400 hover:text-orange-300 transition-colors">
              <Plus className="h-3.5 w-3.5" /> Add option
            </button>
          </div>
        ))}
      </div>
      {groups.length < 5 && (
        <button type="button" data-testid="add-variant-group-button" onClick={() => onChange([...groups, { name: "", options: [newOption(), newOption()] }])} className="mt-2 inline-flex items-center gap-1.5 text-sm text-orange-400 hover:text-orange-300 transition-colors">
          <Plus className="h-4 w-4" /> Add a variant group
        </button>
      )}
    </div>
  );
};
